import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '@prism/tooltip';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var IndicatorAuctionLight = function IndicatorAuctionLight(props) {
  var _classNames;

  var id = props.id,
      lit = props.lit,
      type = props.type;
  var cname = 'prism-indicator--light';
  var className = classNames((_classNames = {}, _defineProperty(_classNames, cname, true), _defineProperty(_classNames, "".concat(cname, "--as-is"), type === 'TYPE_AS_IS'), _defineProperty(_classNames, "".concat(cname, "--caution"), type === 'TYPE_CAUTION'), _defineProperty(_classNames, "".concat(cname, "--guarantee"), type === 'TYPE_GUARANTEE'), _defineProperty(_classNames, "".concat(cname, "--title-absent"), type === 'TYPE_TITLE_ABSENT'), _defineProperty(_classNames, "".concat(cname, "--illuminated"), lit), _classNames));
  var tooltip;

  switch (type) {
    case 'TYPE_AS_IS':
      tooltip = 'As Is';
      break;

    case 'TYPE_CAUTION':
      tooltip = 'Caution';
      break;

    case 'TYPE_GUARANTEE':
      tooltip = 'Guarantee';
      break;

    case 'TYPE_TITLE_ABSENT':
      tooltip = 'Title Absent';
      break;
  }

  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: className,
    tooltip: tooltip,
    role: "note"
  });
};

var IndicatorAuctionLightTypes = ['TYPE_AS_IS', 'TYPE_CAUTION', 'TYPE_GUARANTEE', 'TYPE_TITLE_ABSENT'];
IndicatorAuctionLight.propTypes = {
  id: PropTypes.string,
  lit: PropTypes.bool,
  type: PropTypes.oneOf(IndicatorAuctionLightTypes).isRequired
};
IndicatorAuctionLight.defaultProps = {
  id: undefined,
  lit: false
};
IndicatorAuctionLight.TYPE_AS_IS = 'TYPE_AS_IS';
IndicatorAuctionLight.TYPE_CAUTION = 'TYPE_CAUTION';
IndicatorAuctionLight.TYPE_GUARANTEE = 'TYPE_GUARANTEE';
IndicatorAuctionLight.TYPE_TITLE_ABSENT = 'TYPE_TITLE_ABSENT';

var FLAG_CANADA = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAMAAADHqI+lAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABBVBMVEX+AAL+AQP/AAD4FBX86+v//////v78+Pj8+Pj//v786+v4FBX+AQP+AQP4FBX86+r8+fnxeHjxeHj8+fn86ur4FBX+AQP+AQP/AAD4FBb86Oj67Ozxw8P3Cwv3Cwvxw8P67Ov76Oj4FBb+AQP/AAD4FRb56envMDH1Fxj6ExX6ExX1FxjvMDH56en4FRb/AAD+AAL+AQP/AAD4ExT78O/zaWr8AAD/AgL/AgL9AADzaWr77+/4ExX/AAD4FBX86ur+///wX2D0IiP0IiPwX2D+///86ur4ExX4FBX86+v+//713Nz13Nz+//786+v4FBX4FBX86+v56ur66ur86+v4FBUAAABZmXChAAAAAWJLR0RWCg3piQAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAAd0SU1FB+MFHA0tKJNsxZ0AAACASURBVAjXY2BgZGJmYWVj5+Bk5eJm4mFgYOBl4uNnFRAUEmYVEWUSAwqIS0hKScvIyskrKCoxKQMFGFVU1dQ1NLW0dXT19IFaDAyNjE1MzcwtLK2sbWzFwGbY2Ts4Ojm7uLq5gw1lZPLwZPXy9vFl9fOHCgQEsrIGBbOyhoQCBQAYUA7fLifVRgAAAEF0RVh0Y29tbWVudABDUkVBVE9SOiBnZC1qcGVnIHYxLjAgKHVzaW5nIElKRyBKUEVHIHY4MCksIHF1YWxpdHkgPSA3MAqw+vGNAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTA1LTI4VDEzOjQ1OjQwLTA0OjAw5vPQ8wAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0wNS0yOFQxMzo0NTo0MC0wNDowMJeuaE8AAAAASUVORK5CYII=';

var IndicatorFlag = function IndicatorFlag(props) {
  var _classNames;

  var type = props.type,
      label = props.label,
      color = props.color,
      customText = props.customText;
  var infoLabels = ['NEW', 'BETA', 'UPDATED', 'CERTIFIED', 'SPECIAL', 'REDUCED', 'PRIOR'];
  var dangerLabels = ['SALVAGE', 'AS-IS'];
  var isCustomLabel = infoLabels.indexOf(label) < 0 && dangerLabels.indexOf(label) < 0;
  var cname = 'prism-indicator--flag';
  var className = classNames((_classNames = {}, _defineProperty(_classNames, cname, true), _defineProperty(_classNames, "".concat(cname, "--corner"), type === 'TYPE_CORNER'), _defineProperty(_classNames, "".concat(cname, "--ribbon"), type === 'TYPE_RIBBON'), _defineProperty(_classNames, "info", infoLabels.indexOf(label) >= 0 || isCustomLabel && !color), _defineProperty(_classNames, "danger", dangerLabels.indexOf(label) >= 0), _defineProperty(_classNames, 'has-flag', label === 'PRIOR'), _defineProperty(_classNames, color, isCustomLabel && color), _classNames));
  var computedLabel = isCustomLabel ? customText : label;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(cname, "--wrapper"),
    role: "note"
  }, /*#__PURE__*/React.createElement("div", {
    className: className
  }, computedLabel, label === 'PRIOR' && /*#__PURE__*/React.createElement("span", {
    className: "flag"
  }, /*#__PURE__*/React.createElement("img", {
    src: FLAG_CANADA,
    alt: "Canadian flag"
  }))));
};

var IndicatorFlagLabels = ['NEW', 'BETA', 'UPDATED', 'CERTIFIED', 'SPECIAL', 'REDUCED', 'SALVAGE', 'AS-IS', 'PRIOR', 'CUSTOM'];
var IndicatorFlagTypes = ['TYPE_RIBBON', 'TYPE_CORNER'];
IndicatorFlag.propTypes = {
  color: PropTypes.string,
  customText: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.oneOf(IndicatorFlagTypes)
};
IndicatorFlag.defaultProps = {
  color: undefined,
  customText: undefined,
  label: null,
  type: 'TYPE_RIBBON'
};
IndicatorFlag.TYPE_RIBBON = 'TYPE_RIBBON';
IndicatorFlag.TYPE_CORNER = 'TYPE_CORNER';
IndicatorFlag.LABEL_NEW = 'NEW';
IndicatorFlag.LABEL_BETA = 'BETA';
IndicatorFlag.LABEL_UPDATED = 'UPDATED';
IndicatorFlag.LABEL_CERTIFIED = 'CERTIFIED';
IndicatorFlag.LABEL_SPECIAL = 'SPECIAL';
IndicatorFlag.LABEL_REDUCED = 'REDUCED';
IndicatorFlag.LABEL_SALVAGE = 'SALVAGE';
IndicatorFlag.LABEL_AS_IS = 'AS-IS';
IndicatorFlag.LABEL_PRIOR = 'PRIOR';
IndicatorFlag.LABEL_CUSTOM = 'CUSTOM';

var IndicatorTask = function IndicatorTask(props) {
  var _classNames;

  var complete = props.complete,
      icon = props.icon,
      iconOnly = props.iconOnly,
      name = props.name;
  var iconNode = /*#__PURE__*/React.createRef();
  var cname = 'prism-indicator--task';
  var className = classNames((_classNames = {}, _defineProperty(_classNames, cname, true), _defineProperty(_classNames, "".concat(cname, "--complete"), complete), _classNames));
  var status = complete ? 'Complete' : 'Incomplete';
  return /*#__PURE__*/React.createElement("span", {
    className: className,
    role: "note"
  }, /*#__PURE__*/React.createElement("i", {
    ref: iconNode,
    className: "icon prism-icon-".concat(icon)
  }), iconOnly ? /*#__PURE__*/React.createElement(Tooltip, {
    className: "".concat(cname, "--tooltip"),
    target: iconNode
  }, "".concat(name, " ").concat(status).trim()) : /*#__PURE__*/React.createElement("span", {
    className: "".concat(cname, "--content")
  }, "".concat(status, " ").concat(name).trim()));
};

IndicatorTask.propTypes = {
  complete: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  iconOnly: PropTypes.bool,
  name: PropTypes.string
};
IndicatorTask.defaultProps = {
  complete: false,
  iconOnly: false,
  name: ''
};

var Indicator = {
  AuctionLight: IndicatorAuctionLight,
  Flag: IndicatorFlag,
  Task: IndicatorTask
};

export { IndicatorAuctionLight as AuctionLight, IndicatorAuctionLightTypes as AuctionLightTypes, IndicatorFlag as Flag, IndicatorFlagLabels as FlagLabels, IndicatorFlagTypes as FlagTypes, IndicatorTask as Task, Indicator as default };
//# sourceMappingURL=index.js.map
